export const glyphList = [
  { key: 'ActionCenter', text: 'Action Center' },
  { key: 'AllApps', text: 'All Apps' },
  { key: 'Camera', text: 'Camera' },
  { key: 'EdgeLogo', text: 'Edge Logo' },
  { key: 'Feedback', text: 'Feedback' },
  { key: 'GameController', text: 'Game Controller' },
  { key: 'GetStartedApp', text: 'Get Started App' },
  { key: 'MagnifyingGlass', text: 'Magnifying Glass' },
  { key: 'MapsApp', text: 'Maps App' },
  { key: 'MicrosoftLogo', text: 'Microsoft Logo' },
  { key: 'MMX-CellPhone', text: 'MMX-Cell Phone' },
  { key: 'MMX-CellPhoneHistory', text: 'MMX-Cell Phone History' },
  { key: 'MMX-CellPhoneSend', text: 'MMX-Cell Phone Send' },
  { key: 'News', text: 'News' }, { key: 'Office', text: 'Office' },
  { key: 'OneDriveApp', text: 'OneDrive App' },
  { key: 'PhotoApp', text: 'Photo App' },
  { key: 'RewardsGlyph', text: 'RewardsGlyph' },
  { key: 'Settings', text: 'Settings' },
  { key: 'StoreApp', text: 'Store App' },
  { key: 'VideoApp', text: 'Video App' },
  { key: 'WebURL', text: 'Web URL' },
  { key: 'XboxApp', text: 'Xbox App' },
];
